import TagManager from 'react-gtm-module'
import { getEnvVar } from './env'

const hasNoTrackFlag = () => window.location.search.indexOf('notrack') !== -1

const isProduction = () => (getEnvVar('NODE_ENV') ?? 'development') === 'production'

const resolveGtmConfig = () => {
  const gtmId = getEnvVar('GTM_TRACKING_ID')

  if (!gtmId) {
    return undefined
  }

  const config = {
    gtmId,
  }

  if (!isProduction()) {
    const auth = getEnvVar('GTM_ENV_AUTH')
    const preview = getEnvVar('GTM_ENV')

    if (auth) {
      config.auth = auth
    }

    if (preview) {
      config.preview = preview
    }
  }

  return config
}

const Tracking = {

  excludeFromReactSnap: navigator.userAgent !== 'ReactSnap',

  utils: {
    // Format card data so it's suitable for analytics
    formatCards: (cardType, cardContent) => {
      switch(cardType) {
        case 'person':
          return `${cardContent.id} (${cardContent.personalityTraits})`
        case 'trait':
          return `${cardContent.id} (${cardContent.description})`
        default:
          return ''
      }
    },
  },


  // Initialise datalayer
  start: () => {
    if (hasNoTrackFlag() || !Tracking.excludeFromReactSnap) {
      return false
    }

    const config = resolveGtmConfig()

    if (!config) {
      return false
    }

    TagManager.initialize(config)

    return true
  },

  // push data to the data layer
  trackEvent: (event) => {
    if (hasNoTrackFlag()) return false

    if (Tracking.excludeFromReactSnap) {
      TagManager.dataLayer({
        dataLayer: event
      });
    }

  },

}
export default Tracking
